module.exports = __webpack_public_path__ + "assets/img/btn-view-62092b44.png";